import { useLayoutEffect, useRef } from 'react';

import { useAppTheme } from '@/context/app-theme-context';
import { useUserSession } from '@/context/user-session-context';
import { isAppThemeMode, type AppThemeMode } from '@/lib/theme/mode';

export function ThemePreferenceSync() {
  const { user } = useUserSession();
  const { setMode } = useAppTheme();
  const lastRemotePreference = useRef<{ userId: string; mode?: AppThemeMode } | null>(null);

  useLayoutEffect(() => {
    if (!user) {
      lastRemotePreference.current = null;
      return;
    }

    const remoteMode = isAppThemeMode(user.themeMode) ? user.themeMode : undefined;
    const previous = lastRemotePreference.current;
    const remotePreferenceChanged =
      !previous || previous.userId !== user.id || previous.mode !== remoteMode;

    if (!remotePreferenceChanged) return;

    lastRemotePreference.current = { userId: user.id, mode: remoteMode };
    if (remoteMode) setMode(remoteMode);
  }, [setMode, user]);

  return null;
}
